export default __webpack_public_path__ + "static/ayana_sea_client-dc695fc83374bf82acdc45433dfa297e.png";